/* PDP gallery: native scroll-snap swipe, thumbnail buttons scroll the track, debounced scroll sets the active thumb
   (round(scrollLeft / clientWidth), as in the mock), arrow keys on the focused track, optional lightbox. */
(() => {
  const init = (root) => {
    if (root.dataset.smGalleryReady) return;
    root.dataset.smGalleryReady = '1';
    const track = root.querySelector('[data-sm-gallery-track]');
    const thumbs = [...root.querySelectorAll('[data-sm-gallery-thumbs] .thumb')];
    if (!track || !thumbs.length) return;
    const n = thumbs.length;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let cur = 0;
    const setActive = (i, fromScroll) => {
      cur = Math.max(0, Math.min(n - 1, i));
      thumbs.forEach((t, k) => {
        const on = k === cur;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      if (!fromScroll) track.scrollTo({ left: cur * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => setActive(k)));
    let to;
    track.addEventListener('scroll', () => {
      clearTimeout(to);
      to = setTimeout(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== cur) setActive(i, true);
      }, 100);
    }, { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); setActive(cur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); setActive(cur - 1); }
      else if (e.key === 'Home') { e.preventDefault(); setActive(0); }
      else if (e.key === 'End') { e.preventDefault(); setActive(n - 1); }
    });
    window.addEventListener('resize', () => track.scrollTo({ left: cur * track.clientWidth }), { passive: true });

    const lb = root.querySelector('[data-sm-lightbox]');
    if (lb && typeof lb.showModal === 'function') {
      const img = lb.querySelector('[data-sm-lightbox-img]');
      let opener = null;
      root.querySelectorAll('[data-sm-zoom]').forEach((btn) => btn.addEventListener('click', () => {
        const src = btn.querySelector('img');
        if (!src) return;
        opener = btn;
        img.src = src.currentSrc || src.src;
        img.alt = src.alt || '';
        lb.showModal();
      }));
      const close = () => { lb.close(); };
      lb.querySelector('[data-sm-lightbox-close]').addEventListener('click', close);
      lb.addEventListener('click', (e) => { if (e.target === lb || e.target === img) close(); });
      lb.addEventListener('close', () => { if (opener) opener.focus(); });
    }
  };
  const run = () => document.querySelectorAll('.sm-s01').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
